import { getCategoryOgImageUrl } from "~/constants/categoryOgImages";

const POLYMARKET_OG_IMAGE_PATTERN = /polymarket-upload\.s3[.a-z0-9-]*\.amazonaws\.com/i;

export const isPolymarketOgImage = (ogImage?: string | null): boolean =>
  Boolean(ogImage && POLYMARKET_OG_IMAGE_PATTERN.test(ogImage));

export const resolveOgImage = (
  ogImage?: string | null,
  categorySlug?: string | null,
  siteOrigin?: string | null
): string | undefined => {
  if (categorySlug) {
    if (ogImage && !isPolymarketOgImage(ogImage)) {
      return ogImage;
    }

    return getCategoryOgImageUrl(categorySlug, siteOrigin);
  }

  if (ogImage && !isPolymarketOgImage(ogImage)) {
    return ogImage;
  }

  if (ogImage && isPolymarketOgImage(ogImage)) {
    return getCategoryOgImageUrl(null, siteOrigin);
  }

  return undefined;
};
